import { StoreEditScreen } from '../features/stores/StoreEditScreen'
import { useShell } from '../app/outlet'

export function StoreEditPage() {
  const { toast } = useShell()
  return <StoreEditScreen onToast={toast} />
}
